import ella from "../../assets/ella.png";
import erik from "../../assets/erik.png";
import fia from "../../assets/fia.png";
import jonatan from "../../assets/jonatan.png";
import millie from "../../assets/millie.png";

export const memberData = [
  {
    name: "Jonatan Nyberg",
    title: "Co-Founder | CEO | Webdeveloper",
    phoneNmbr: "(+46) 123 456 789",
    email: "nyberg112@gmail.com",
    namePic: jonatan,
    intro:
      "As the CEO of Webly it is of importance to set a clear vision for the furute of Webly as well as keeping the team togheter. Jonatan has an strong passion for customer relationships and values sustainable and longterm relations. As an expert of processdriven Design and both front- & backend development there are no problem to hard to handle, only great solutions!",
    id: 4,
  },

  {
    name: "Millie Cheung",
    title: "Co-Founder | Full Stack Developer",
    phoneNmbr: "(+46) 730 654 987",
    email: "wingyan.cheung@medieinstitutet.se",
    namePic: millie,
    intro:
      "A co-founder and full-stack developer of Webly. Millie has an extremely strong passion for building things from scratch. Apart from coding, her previous career in administration has made her a great coordinator in our Fantastic Five and she plays an important role in ensuring that Webly's business processes run smoothly.",
    id: 5,
  },
  {
    name: "Erik Isaksson",
    title: "Co-Founder | Webdeveloper",
    phoneNmbr: "(+46) 123 456 789",
    email: "erik.isak@icloud.com",
    namePic: erik,
    intro:
      "Erik is a co-founder of Webly, who always working hard for the company and its clients. To keep working for the company's vision, Erik delivers good experience in both front-end and back-end development.",
    id: 2,
  },
  {
    name: "Fia Andersson",
    title: "Co-Founder | Webdeveloper",
    phoneNmbr: "(+46) 123 456 789",
    email: "fiaandersson61@gmail.com",
    namePic: fia,
    intro:
      "As an early adopter of React and React Native, Fia's code is well written, clean and follow best practices. She brings a wealth of experience to the team, specifically with her deep understanding of programming fundamentals.",
    id: 3,
  },
  {
    name: "Ella Larsson",
    title: "Co-Founder | Webdeveloper",
    phoneNmbr: "(+46) 123 456 789",
    email: "ella.larsson0012@gmail.com",
    namePic: ella,
    intro:
      "Ella is a developer and co-founder of Webly. With experience in both front-end and back-end development and programming languages like Javascript and C#, she adds experience to the team.",
    id: 1,
  },
];
